import {
  Component,
  EventEmitter,
  Inject,
  Output,
  PLATFORM_ID,
  TemplateRef,
} from '@angular/core';
import { ModalArguments } from '../../../models/modal-arguments';
import { ModalButtonType } from '../../../enums/modal_button_type';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { KeywordsAndConstants } from '../../../core/keywords-and-constants';
import { LocalStorageService } from '../../../network/services/local-storage.service';
import { LoginService } from '../../../network/services/login.service';
import { DialogUtil } from '../../../utils/dialog-utils';
import { ShortNamePipe } from '../short-name.pipe';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ThemeService } from '../../../network/services/theme.service';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MessageType } from '../../../enums/message-type';
import { RouterLink } from '@angular/router';
import { StringVariable } from '../../../core/string-variable';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    BsDropdownModule,
    CommonModule,
    ShortNamePipe,
    ClipboardModule,
    RouterLink,
    NgSelectModule,
    FormsModule
  ],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent {
  @Output() mobileMenuButtonClicked = new EventEmitter();
  userInfo: any;
  response: any;
  totalCount: any;

  logoUrl: string = '';

  notificationsCount: number = 0;
  notificationList: any = '';

  copiedValue: any;
  languages = [
  {
    code: 'en',
    name: 'English'
  },
  {
    code: 'fr',
    name: 'French'
  },
  // {
  //   code: 'de',
  //   name: 'German'
  // }
]
  selectedLanguage = 'English';
  constructor(
    public constants: KeywordsAndConstants,
    public _localStorageService: LocalStorageService,
    private _loginService: LoginService,
    public dialog: DialogUtil,
    @Inject(PLATFORM_ID) private platformId: Object,
    public _logoService: ThemeService,
    public variable: StringVariable,
  ) {}

  ngOnInit() {
    const currentLang = this.variable.getCurrentLanguage();
    const foundLang = this.languages.find((l) => l.code === currentLang);
    if (foundLang) {
      this.selectedLanguage = foundLang.name;
    }
    this.variable.language$.subscribe((langCode) => {
      const found = this.languages.find((l) => l.code === langCode);
      if (found) {
        this.selectedLanguage = found.name;
      }
    });
    this._loginService.callbackResponseForUser.subscribe((response) => {
      this.response = response;
      if (isPlatformBrowser(this.platformId)) {
        let userDetails: any = localStorage.getItem(
          this.constants.LocalStorageUserInfo
        );
        this.userInfo = JSON.parse(userDetails);
      }
    });
    if (!this.response) {
      if (isPlatformBrowser(this.platformId)) {
        let userDetails: any = localStorage.getItem(
          this.constants.LocalStorageUserInfo
        );
        this.userInfo = JSON.parse(userDetails);
      }
    }
  }

  changeLanguage(language: any) {
    this.selectedLanguage = language.name;
    this.variable.setLanguage(language.code);
    console.log('Selected language:', this.selectedLanguage);
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  public onClipboardCopy(successful: boolean, val: any): void {
    if (successful) {
      this.copiedValue = val;
      this.dialog.showToast('Copied', MessageType.SUCCESS);
    }
  }

  logout() {
    const contextAlias = this;
    this.dialog.errorShowModal(
      new ModalArguments('Are you sure you want to logout?')
        .withButtonType(ModalButtonType.DOUBLE_BUTTON)
        .withButtonPositiveText('Logout')
        .withButtonNegativeText('Cancel')
        .withCallback({
          buttonNegativeClicked() {},
          buttonPositiveClicked() {
            contextAlias._localStorageService.logout();
          },
          buttonSingleClicked() {},
        })
    );
  }
}
